<!-- 
  Concepts:
  1. 1000.50 -> props -> formate with separator -> 1,000.50 -> show on input field
  2. on input change -> 1,000.50 -> remove separator -> 1000.50 -> emit -> props updated and repeat the process
-->
<script setup>
import { computed, onMounted, ref, watch } from "vue"
import Icon from "./Icon.vue"

const emit = defineEmits(["update:modelValue"])

let source = ref(prebook_admin !== undefined ? prebook_admin : prebook)

const props = defineProps({
	modelValue: {
		type: String,
	},
	iconLeft: {
		type: String,
		// default: source.value.settings.payment.currency_symbol
		default: () =>
			prebook_admin !== undefined
				? prebook_admin.settings.payment.currency_symbol
				: prebook.settings.payment.currency_symbol,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	inputContainerClass: {
		type: String,
	},
})

const propsValue = computed(() => props.modelValue)
const formatedValue = ref("")

const separatorMap = ref({
	"Comma-Dot": { thousand: ",", decimal: "." },
	"Dot-Comma": { thousand: ".", decimal: "," },
	"Space-Dot": { thousand: " ", decimal: "." },
	"Space-Comma": { thousand: " ", decimal: "," },
})

onMounted(() => {
	formatedValue.value = propsValue.value ? 
    formatPriceWithSeparator(
        ['Dot-Comma', 'Space-Comma'].includes(price_separator) 
            ? propsValue.value.toString().replace(/\./g, ',') 
            : propsValue.value
    ) : ""
})

watch(() => props.modelValue, () => {
    formatedValue.value = propsValue.value ? 
        formatPriceWithSeparator(
            ['Dot-Comma', 'Space-Comma'].includes(price_separator) 
                ? propsValue.value.toString().replace(/\./g, ',') 
                : propsValue.value
        ) : ""
})

const input = ref(null)

const handleContainerClick = () => {
	input.value.focus()
}

let lastPrice = ref("")

const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const price_separator = source.value.settings.payment.price_separator
const { decimal, thousand } = separatorMap.value[price_separator]

const formatPriceWithSeparator = (price) => {
    const price_decimals = source.value.settings.payment.price_decimals

    // check if price ends with decimal separator
    const hasTrailingDecimal = price.toString().endsWith(decimal)
		
    let parts

	const separator = ['Dot-Comma', 'Space-Comma'].includes(price_separator) ? ',' : '.'
	parts = price.toString()
		.replace(new RegExp(`[^0-9${escapeRegExp(separator)}]`, "g"), "")
		.split(separator)
		.slice(0, 2)

    // format integer part with thousand separators
    parts[0] = parts[0] ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand) : '0'
	
    // format decimal part according to settings
    if (price_decimals == 0) {
		lastPrice.value = parts[0]
    } else if (parts[1]) {
		lastPrice.value = parts[0] + decimal + parts[1].slice(0, price_decimals)
    }else {
        // prevent decimal separator if price doesn't have one
        lastPrice.value = parts[0] + (hasTrailingDecimal ? decimal : '')
    }

    return lastPrice.value
}

const formatPriceAfterRemoveSeparator = (price) => {
    
	return Number(
		(price.endsWith(decimal) ? price + '0' : price)
			.split(decimal)
			.map((part, index) => index == 0 ? 
				part.replace(new RegExp(escapeRegExp(thousand), "g"), "") : 
				part
			)
			.join('.')
	) + (price.endsWith(decimal) ? '.' : '')
}

const handleInputChange = () => {
    formatedValue.value = input.value.value ? 
        formatPriceWithSeparator(input.value.value) : 
        ""
    emit("update:modelValue", formatPriceAfterRemoveSeparator(formatedValue.value))
}
</script>

<template>
<div v-bind="$attrs" @click="handleContainerClick()"
	class="shadow-[0_1px_2px_#1018280d] border border-[#d0d5dd] flex relative gap-2 items-center w-full transition-all px-3.5 py-2.5 rounded-lg"
	:class="`${props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${inputContainerClass}`">
	<Icon v-if="props.iconLeft" :name="props.iconLeft" class="text-[#667085]" />
	<input ref="input" class="outline-none" type="tel" v-model="formatedValue" @input="handleInputChange" />
</div>
</template>

<style></style>